export default __webpack_public_path__ + "static/media/gnl1.7f671f80.webp";